import React, { Component } from 'react';
import { getDomElements } from '~/services/domService';
import Resizer from '@/Resizer';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export class FontResize extends Component {
  constructor(props = { featureId }){
    super(props);
    this.state = {
      initialDom: this.getElementsAndFontSizes(),
      maxSize: 10
    }
  }
  getElementsAndFontSizes() {
    let initialDom = [];
    const elements = getDomElements();
    for (let element of elements){
      initialDom.push({
        computedFontSize: parseInt(window.getComputedStyle(element).getPropertyValue('font-size')),
        styledFontSize: element.style.fontSize,
        $element: element
      })
    }
    return initialDom;
  }
  resetSize(featureId){
    let { setFeatureOptions } = this.props.featuresListStore;
    setFeatureOptions(featureId, { size: 0 });
  }
  addSize(featureId, size){
    let { setFeatureOptions } = this.props.featuresListStore;
    if (size < this.state.maxSize) {
      setFeatureOptions(featureId, { size: size + 1});
    }
  }
  subtractSize(featureId, size){
    const minSize = Math.abs(this.state.maxSize) * -1;
    let { setFeatureOptions } = this.props.featuresListStore;
    if (size > minSize) {
      setFeatureOptions(featureId, { size: size - 1 });
    }
  }
  clearFontSize(item){
    if (item.styledFontSize){
      item.$element.style.fontSize = item.styledFontSize;
    } else {
      item.$element.style.removeProperty('font-size');
    }
  }
  changeFontSize(size){
    for (let item of this.state.initialDom){
      if (size) {
        let newFontSize = item.computedFontSize + size; 
        item.$element.style.fontSize = `${newFontSize}px`;
      } else {
        this.clearFontSize(item);
      }
    }
  }
  render() {
    let { featureId } = this.props;
    let { getFeatureById } = this.props.featuresListStore;
    let feature = getFeatureById(featureId);
    let { size } = feature.options;
    this.changeFontSize(size);

    let resizerProps = {
      onReset: () => this.resetSize(featureId),
      onAdd: () => this.addSize(featureId, size),
      onSubtract: () => this.subtractSize(featureId, size),
      currentSize: size,
      maxSize: this.state.maxSize
    }
    return (
      <Resizer { ...resizerProps } />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/FeatureActions/FontResize/index.js